{
  "title": {
    "profileAndAvatar": "PROFILE AND AVATAR",
    "mapAvatar": "INTERACTIVE MAP AVATAR",
    "description": "DESCRIPTION",
    "location": "LOCATION",
    "religion": "RELIGION",
    "skills": "SKILLS",
    "officialDocuments": "OFFICIAL DOCUMENTS"
  },
  "changePhoto": "Change Photo",
  "guestFallback": "Guest",
  "namePlaceholder": "Name",
  "emailPlaceholder": "Email",
  "createAvatarTooltip": "Create my own avatar",
  "createCharacterLabel": "Create my own character",
  "descriptionPlaceholder": "Write a short description...",
  "locationPlaceholder": "City, Country",
  "religionPlaceholder": "Add religion",
  "skillsPlaceholder": "Add skill...",
  "stats": {
    "contributions": "Contributions",
    "timeActive": "Time Active"
  },
  "docs": {
    "idFront": "ID Front",
    "idBack": "ID Back",
    "addressProof": "Address Proof",
    "curp": "CURP",
    "birthCert": "Birth Certificate",
    "noneUploaded": "No documents uploaded."
  },
  "toast": {
    "visibilityChangeFailed": "Could not change visibility",
    "occupied": "Occupied",
    "unavailable": "Unavailable",
    "savedSuccess": "Saved successfully!",
    "error": "Error",
    "errorSavingProfile": "Error saving profile",
    "uploadingImage": "Uploading image...",
    "imageSaved": "Profile image saved to cloud!",
    "uploadFailed": "Upload failed: {{message}}"
  },
  "characterGallery": {
    "loading": "Loading characters...",
    "emptyTitle": "No characters created yet.",
    "emptySubtitle": "Be the first to create one.",
    "availableTitle": "Available characters",
    "deselectTooltip": "Click to remove and go back to profile photo",
    "by": "by {{creator}}"
  },
  "security": {
    "title": "SECURITY",
    "editButton": "Edit access",
    "modalTitle": "Edit access",
    "modalSubtitle": "Change your username and/or password. We need your current password to confirm it's really you.",
    "nickLabel": "Username",
    "nickPlaceholder": "Your username",
    "newPasswordLabel": "New password (optional)",
    "newPasswordPlaceholder": "Minimum 8 characters...",
    "confirmPasswordLabel": "Confirm new password",
    "confirmPasswordPlaceholder": "Re-type the new password...",
    "currentPasswordLabel": "Current password",
    "currentPasswordPlaceholder": "Your current password",
    "currentPasswordHint": "We need this to confirm you're the one making the change.",
    "cancel": "Cancel",
    "save": "Save",
    "saving": "Saving...",
    "savedSuccess": "Your access was updated successfully.",
    "errors": {
      "noChanges": "You didn't change your username or password.",
      "passwordTooShort": "The new password must be at least 8 characters.",
      "passwordMismatch": "The passwords don't match.",
      "currentPasswordRequired": "Enter your current password to confirm the change.",
      "generic": "Could not update your access. Try again."
    }
  }
}
